module.exports = __webpack_public_path__ + "static/media/online-test-new.0f5af4cc.svg";